var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Loader',{attrs:{"logo":_vm.loaderLogo}}),_vm._v(" "),_c('div',{staticClass:"main"},[_c('transition',{attrs:{"name":"fade-in-up"}},[_c('router-view')],1)],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/App.vue?vue&type=template&id=dc47280a
// module id = null
// module chunks = 